module.exports = __webpack_public_path__ + "img/tip.5f27c0ff.png";